export enum VizType {
  View,
  Admin,
  RevisionPreview,
  DeviceVizPreview
}

export interface IViz {
  path: string;
  vizType: VizType;
  params: _.Dictionary<any>;
  siteUrlName?: string;
  instanceId?: string;
  isExplicitOriginalViz?: boolean;
  reloadViz?: () => void;
  allowReloadViz?: boolean;
}
